import { Input } from 'module/ui/components/atoms/input/input';
import { InputNumber } from 'module/ui/components/atoms/input/input-number';
import { InputDuration } from 'module/ui/components/atoms/input-duration/input';
import styled from 'styled-components';

export { CriteriaSelect } from './criteria-select';

export const Text = styled.div`
  min-width: 80px;
  text-align: right;
`;

export const NumericInput = styled(InputNumber).attrs({
  placeholder: 'Enter value',
  autoFocus: true,
})`
  min-width: 240px;
  max-width: 240px;
`;

export const DurationInput = styled(InputDuration)`
  min-width: 240px;
  max-width: 240px;
`;

export const TextInput = styled(Input).attrs({
  type: 'text',
  placeholder: 'Enter value',
  autoFocus: true,
})`
  padding-left: var(--spacing-05);
  ::placeholder {
    padding-left: var(--spacing-01);
  }
  min-width: 240px;
  max-width: 240px;
`;
